import React, { useEffect, useState } from 'react';
import './ShortAboutUs.css';
import dummy_team  from '../../assets/images/dummy_team.jpg';
export default function ShortAboutUs() {
    const [animate, setAnimate] = useState(false);

    useEffect(() => {
      // Trigger animation after component mounts
      setTimeout(() => setAnimate(true), 300); // Delay for smooth effect
    }, []);
  
  return (
    <>
     <section className="about-us">
      <div className={`about-content ${animate ? 'fade-in' : ''}`}>
        <h2>About Us</h2>
        <p>
          We are a trusted statutory consulting firm specializing in industrial compliance, regulatory advisory, and statutory reporting. With years of experience in the industry, we help businesses navigate the complex landscape of industrial laws and regulations.
        </p>
        <a href="/about" className="cta-button secondary">Learn More About Us</a>
      </div>
      <div className="about-image">
        <img src={dummy_team } alt="Our Team" />
      </div>
    </section>
    
    
    
    </>
  )
}
